import React from 'react';

import { Divider } from 'ui-components/components/divider';
import { FlexRow, FlexColumn } from 'ui-components/components/flex';

import style from './header-content.module.less';
import { useEnableReship } from '../../../../feature-flags/hooks/use-enable-reship';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { ReshipButton } from '../../../reship/reship-button';
import { ReshipContextProvider } from '../../../reship/reship-context-provider';
import { RestoreCancelledButton } from '../../../restore/restore-cancelled-button';
import { CreateReturnButton } from '../create-return-button';
import { RemoveHoldButton } from '../remove-hold';
import { RecommendPackageButton } from '../shipment-actions/buttons/recommend-package-button';
import ShipmentActionsDropdown from '../shipment-actions/shipment-actions-dropdown';
import { ShipmentAttributes } from '../shipment-attributes/shipment-attributes';
import { Tags } from '../tags/tags';

/**
 * @param {object} props
 * @param {boolean} props.isImportedAsShipped
 * @returns {JSX.Element}
 */
export const HeaderContent = ({ isImportedAsShipped }) => {
  const isReshipEnabled = useEnableReship();
  const salesOrderId = useSalesOrderIdContext();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  return (
    <FlexColumn>
      <FlexRow className={style['tags-container']}>
        <ShipmentAttributes />
        <Divider className={style.divider} orientation='vertical' />
        <Tags />
        <RemoveHoldButton />
        {isReshipEnabled ? <RestoreCancelledButton fulfillmentPlanId={fulfillmentPlanId} /> : null}
        <ReshipContextProvider fulfillmentPlanId={fulfillmentPlanId} isImportedAsShipped={isImportedAsShipped} salesOrderId={salesOrderId}>
          {isReshipEnabled ? <ReshipButton /> : null}
          <CreateReturnButton />
          <RecommendPackageButton />
          <ShipmentActionsDropdown />
        </ReshipContextProvider>
      </FlexRow>
    </FlexColumn>
  );
};
